import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { OperatorSearchSchema } from "../-zod-schema";

export const Route = createFileRoute(
  "/_staff/settings/persons/_list/_account/staff/",
)({
  validateSearch: zodValidator(OperatorSearchSchema),
  loaderDeps: ({ search }) => ({ search }),
});
